// extracted by mini-css-extract-plugin
export default {"oneUrlBox":"URLSection_oneUrlBox__caQo8","fetchOrScrape":"URLSection_fetchOrScrape__bJ61p","urlContainer":"URLSection_urlContainer__BdazP","rowGap":"URLSection_rowGap__Pxvf0"};